import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import Supplier, { SupplierProduct } from '../models/Supplier';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    isFetchingGenerate: false,
    isFetchingTranslate: false,
    isFetchingProduct: false,
    isFetchingVinWonderSites: false,
    isFetchingVinWonderTypes: false,
    isFetchingVinWonderRefIds: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    totalPage: 0,
    orderBy: undefined,
    orderByDesc: false,
    suppliers: [],
    supplierAll: [],
    supplierProducts: [],
    productGenerate: {},
    detailProduct: {
        supplierProduct: new SupplierProduct(),
    },
    supplierSelectData: {},
    detail: {
        supplier: new Supplier(),
    },
    sites: [],
    vinWonderTypes: [],
    vinWonderRefIds: [],
    supplierFAQ: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.SUPPLIER_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_LIST_SUCCESS:
            return { 
                ...state, 
                isFetching: false,  
                suppliers: action.suppliers ,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
            };
        
        case Types.SUPPLIER_PRODUCT_GENERATE_ACTION:
            return { ...state, isFetchingGenerate: true };
        case Types.SUPPLIER_PRODUCT_GENERATE_SUCCESS:
            return { ...state, isFetchingGenerate: false, productGenerate: action.data.data };

        case Types.SUPPLIER_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_LIST_ALL_SUCCESS:
            return { ...state, isFetching: false, supplierAll: action.suppliers };

        case Types.SUPPLIER_SELECT_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.SUPPLIER_SELECT_LIST_SUCCESS:
            return { ...state, isFetching: false, supplierSelectData: action.supplierSelectData };

        case Types.SUPPLIER_GET_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_GET_DETAIL_SUCCESS:
            return { ...state, isFetchingDetail: false, detail: { ...state.detail, supplier: action.supplier } };

        case Types.SUPPLIER_CREATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_CREATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.SUPPLIER_UPDATE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_UPDATE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.SUPPLIER_DELETE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.SUPPLIER_DELETE_SUCCESS:
            return { ...state, isFetchingDetail: false };

        case Types.SUPPLIER_PRODUCT_LIST_ALL_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_LIST_ALL_SUCCESS:
            return { ...state, isFetchingProduct: false, supplierProducts: action.supplierProducts };
        
        case Types.SUPPLIER_PRODUCT_LIST_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_LIST_SUCCESS:
            return { 
                ...state, 
                isFetchingProduct: false, 
                supplierProducts: action.supplierProducts.supplierProducts,
                pageSize: action.supplierProducts.pageSize,
                pageIndex: action.supplierProducts.pageIndex,
                totalCount: action.supplierProducts.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize))
            };

        case Types.SUPPLIER_PRODUCT_GET_DETAIL_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_GET_DETAIL_SUCCESS:
            return { ...state, isFetchingProduct: false, detailProduct: { ...state.detailProduct, supplierProduct: action.supplierProduct } };

        case Types.SUPPLIER_PRODUCT_CREATE_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_CREATE_SUCCESS:
            return { ...state, isFetchingProduct: false };

        case Types.SUPPLIER_PRODUCT_UPDATE_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_UPDATE_SUCCESS:
            return { ...state, isFetchingProduct: false };

        case Types.SUPPLIER_PRODUCT_DELETE_ACTION:
            return { ...state, isFetchingProduct: true };
        case Types.SUPPLIER_PRODUCT_DELETE_SUCCESS:
            return { ...state, isFetchingProduct: false };

        case Types.SUPPLIER_VINWONDER_SITES_ACTION:
            return { ...state, isFetchingVinWonderSites: true };
        case Types.SUPPLIER_VINWONDER_SITES_SUCCESS:
            return { ...state, isFetchingVinWonderSites: false, sites: action.data.data };

        case Types.SUPPLIER_VINWONDER_TYPES_ACTION:
            return { ...state, isFetchingVinWonderTypes: true };
        case Types.SUPPLIER_VINWONDER_TYPES_SUCCESS:
            return { ...state, isFetchingVinWonderTypes: false, vinWonderTypes: action.data };

        case Types.SUPPLIER_VINWONDER_REFIDS_ACTION:
            return { ...state, isFetchingVinWonderRefIds: true };
        case Types.SUPPLIER_VINWONDER_REFIDS_SUCCESS:
            return { ...state, isFetchingVinWonderRefIds: false, vinWonderRefIds: action.data.data };

        case Types.SUPPLIER_CREATE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.SUPPLIER_CREATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        case Types.SUPPLIER_DELETE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.SUPPLIER_DELETE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        case Types.SUPPLIER_UPDATE_TRANSLATE_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.SUPPLIER_UPDATE_TRANSLATE_SUCCESS:
            return { ...state, isFetchingTranslate: false };
        case Types.SUPPLIER_GET_DETAIL_FAQS_SUCCESS:
            return { ...state, supplierFAQ: action.supplier};
        case Types.SUPPLIER_DELETE_FAQS_ACTION:
            return { ...state, isFetchingTranslate: true };
        case Types.SUPPLIER_DELETE_FAQS_SUCCESS:
            return { ...state, isFetchingTranslate: false };

        case Types.SUPPLIER_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false, isFetchingTranslate: false, isFetchingProduct: false, isFetchingGenerate: false, isFetchingVinWonderSites: false};
        default:
            return state;
    }
}
